import httpClient from "../../../client/httpClient";
import { fetchCountries } from "../locations/locationApi";
import { fetchShippingFees } from "../shippingFees/shippingFeesApi";
import { mergeOrderWithSnapshot } from "./ordersService";

export const fetchOrders = async (payload = {}, signal) => {
    const {
        filters = {},
        pagination = { page: 1, pageSize: 10 },
        sorting = { sortBy: "id", sortOrder: "DESC" }
    } = payload;

    const cleanedFilters = Object.fromEntries(
        Object.entries(filters).filter(([_, value]) => {
            if (value === undefined || value === "") return false;
            if (Array.isArray(value) && value.length === 0) return false;
            return true;
        })
    );

    try {
        const res = await httpClient.post(
            "/v1/api/customer-order/all",
            {
                pageNumber: pagination.page,
                pageSize: pagination.pageSize,
                sortBy: sorting.sortBy,
                sortOrder: sorting.sortOrder,
                filter: {
                    searchKeyword: cleanedFilters?.searchKeyword ?? ""
                }
            },
            {
                params: cleanedFilters,
                paramsSerializer: (params) => {
                    const usp = new URLSearchParams();
                    Object.entries(params).forEach(([key, value]) => {
                        if (Array.isArray(value)) {
                            value.forEach((v) => usp.append(key, v));
                        } else {
                            usp.append(key, value);
                        }
                    });
                    return usp.toString();
                },
                signal
            }
        );

        const shippingFees = await fetchShippingFees(["01", "02"]);
        const countries = await fetchCountries();

        const rawOrders = res.data.content;
        const parsedOrders = mergeOrderWithSnapshot(rawOrders, countries, shippingFees);

        return {
            ...res.data,
            content: parsedOrders
        };
    } catch (error) {
        console.log("Error on fetching all orders", error);
        return Promise.reject(error);
    }
};

export const cancelOrder = async ({ orderId, paymentStatus, reason }) => {
    try {
        const newStatus = paymentStatus === "PAID" ? "PENDING_REFUND" : "CANCELLED";
        await httpClient.put(`/v1/api/customer-order/update-order-status/${orderId}`, null, {
            params: {
                orderStatus: newStatus,
                reason: reason
            }
        });
        return {
            orderId,
            reason,
            newStatus
        };
    } catch (error) {
        console.log("error on order cancel", error);
        throw error;
    }
};

export const submitPickupRequest = async ({ orderId, orderNumber, sellerId }) => {
    const warehouseId = 20;

    const [warehousesRes, sellerRes] = await Promise.all([
        httpClient.get("/v1/api/pickup-requests/warehouse/02"),
        httpClient.get(`/v1/api/seller/get-by-id/${sellerId}`)
    ]);

    const warehouse = warehousesRes.data.find((w) => w.id === warehouseId) || null;
    const sellerUniqueId = sellerRes?.data?.userProfileDTO?.uniqueId || null;

    if (!sellerUniqueId || !warehouse) {
        throw new Error("Seller or warehouse not found");
    }

    const res = await httpClient.post("/v1/api/pickup-requests/create", {
        sellerUniqueId,
        warehouseId,
        orderNumber: [orderNumber],
        status: "AWAITING_PICKUP",
        pickupAddress: warehouse.address,
        actualPickupDate: null,
        contactName: warehouse.warehouseName,
        contactPhone: warehouse.phone,
        parcelIds: [orderId],
        requestType: "auto"
    });

    await httpClient.put(
        `/v1/api/customer-order/update-order-status/${orderId}?orderStatus=Pickup_Requested`
    );

    return {
        id: orderId,
        pickupRequestCode: res.data.pickupRequestCode
    };
};
